const relatedNewsSwiper1 = new Swiper(".related-news_swiper-1", {
  direction: "horizontal",
  loop: true,
  loopAdditionalSlides: 1,
  slidesPerView: 1,
  spaceBetween: 15,

  // ページネーション
  pagination: {
    el: ".swiper-pagination",
    type: "fraction", // 枚数表示
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  speed: 1000,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },

  watchSlidesProgress: true,

  scrollbar: {
    el: ".swiper-scrollbar",
  },

  breakpoints: {
    769: {
      slidesPerView: 4,
      spaceBetween: 20,
      autoplay: false,
      loop: false,
    },
  },
});

const relatedNewsSwiper2 = new Swiper(".related-news_swiper-2", {
  direction: "horizontal",
  loop: true,
  loopAdditionalSlides: 1,
  slidesPerView: 1,
  spaceBetween: 15,

  // ページネーション
  pagination: {
    el: ".swiper-pagination",
    type: "fraction", // 枚数表示
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  speed: 1000,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },

  watchSlidesProgress: true,

  scrollbar: {
    el: ".swiper-scrollbar",
  },

  breakpoints: {
    769: {
      slidesPerView: 4,
      spaceBetween: 20,
      autoplay: false,
      loop: false,
    },
  },
});
